import {ActionReducer,ActionReducerMap,MetaReducer} from '@ngrx/store';
  import { localStorageSync } from 'ngrx-store-localstorage';
import { environment } from 'projects/main/src/environments/environment';
  import * as docstereotypes from './doc-stereo-type/app.state';
  import * as docstereotypesReducer from './doc-stereo-type/doc-stereo-type.reducer';
  import * as projectSessionReducer from './project-session/project-session.reducer'
  import * as projectSession from './project-session/app.state';
  import * as document from './document/app.state';
  import * as attributeValue from './attribute-value/app.state';
  import * as valueConfPage from './value-conf-page/app.state';
  import * as documentReducer from './document/document.reducer';
  import * as attributeValueReducer from './attribute-value/attribute-value.reducer';
  import * as valueConfPageReducer from './value-conf-page/value-conf-page.reducer';

  export interface AppState {
    docstereotypes: docstereotypes.AppState,
    projectsessionreq: projectSession.AppState,
    document: document.AppState,
    currentattributevalue:attributeValue.AppState,
    valueconfpages: valueConfPage.AppState    
  }

  // DSTEffects,ProjectSessionEffects,DocumentEffects,AttributeValueEffects,ValueConfPageEffects

  export const reducers: ActionReducerMap<AppState> = {
    docstereotypes: docstereotypesReducer.docStTypeReducer,
    projectsessionreq:projectSessionReducer.projectSessionReducer,
    document:documentReducer.documentReducer,
    currentattributevalue:attributeValueReducer.attributeValueReducer,
    valueconfpages:valueConfPageReducer.valueConfPageReducer
  }

  // const reducerKeys = ['docstereotypes','projectsessionreq','document','currentattributevalue','valueconfpages'];
  const reducerKeys = [''];
  export function localStorageSyncReducer(reducer:ActionReducer<any>) : ActionReducer<any> {
    return localStorageSync({keys:reducerKeys})(reducer);
  }

  // console.log all actions
export function debug(reducer: ActionReducer<any>): ActionReducer<any> {
    return function(state, action) {
      console.log('state', state);
      console.log('action', action);
  
      return reducer(state, action);
    };
  }

  export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [debug, localStorageSyncReducer] : [localStorageSyncReducer];

  


